module.exports = __webpack_public_path__ + "media/images/step-three-4b30fe71.svg";